import { BaseError, type Severity } from './BaseError.js';
import { CLIENT_ERROR_MESSAGES, type ClientErrorCode } from './constants.js';
import { parseITSError } from './parseITSError.js';

/**
 * Custom Error class to be used within payment flow (see createPayment).
 * Every intentional exception within the payment flow should use this Error class with a significant error code.
 */
export class RequestPaymentError extends BaseError<ClientErrorCode> {
  constructor({ clientCode, code, extraData }: { clientCode: ClientErrorCode; code: string; extraData?: object }) {
    const [clientErrorCode] = parseITSError(code);
    let parsedClientCode = clientCode;

    if (clientErrorCode) {
      parsedClientCode = clientErrorCode;
    }

    const message = `${CLIENT_ERROR_MESSAGES[parsedClientCode]}${clientErrorCode ? '' : `. Unhandled ITS error: ${code}`}`;

    super({ clientCode: parsedClientCode, code, extraData, message });
    this.name = 'RequestPaymentError';
  }

  override get severity(): Severity {
    if (this.clientCode === 'BAD_BET') {
      return 'warn';
    }

    return super.severity;
  }
}
